import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'

const Footer = () => {
    return (
        <footer class="site-footer">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <h6>About</h6>
                        <p class="text-justify">I'm a self-motivated and enthusiastic web developer with a deep interest in JavaScript. To work in the Software industry with modern web technologies of different local & multinational Software/ IT agencies of Bangladesh and grow rapidly with increasing responsibilities.</p>
                    </div>

                    <div class="col-xs-6 col-md-3">
                        <h6>My Projects</h6>
                        <ul class="footer-links">
                            <li><a href="https://shahinuralambhuiyan.github.io/music-player-v-2/" target="_blank">Music player</a></li>
                            <li><a href="https://shahinuralambhuiyan.github.io/Trust-Bank/" target="_blank">Bank Site</a></li>
                            <li><a href="https://shahinuralambhuiyan.github.io/weather-app-realTime/" target="_blank">Weather App</a></li>
                            <li><a href="https://shahinuralambhuiyan.github.io/Image-slider/" target="_blank">Image Slider</a></li>
                            <li><a href="https://shahinuralambhuiyan.github.io/panda-commerce-bootstrap/" target="_blank">Panda Commerce</a></li>
                            <li><a href="https://shahinuralambhuiyan.github.io/sample-home-page/">Home Page</a></li>
                        </ul>
                    </div>

                    <div class="col-xs-6 col-md-3">
                        <h6>Quick Links</h6>
                        <ul class="footer-links">
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                            <li><Link to="/work">All Work</Link></li>
                            <li><Link to="/blog">My Blog</Link></li>
                        </ul>
                    </div>
                </div>
                <hr />
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-8 col-sm-6 col-xs-12">
                        <p class="copyright-text">Copyright &copy; 2021 All Rights Reserved by
         <a href="https://github.com/ShahinurAlamBhuiyan" target="_blank">&nbsp;Shahinur Alam Bhuiyan</a>.
            </p>
                    </div>

                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <ul class="social-icons">
                            <li><a class="facebook" href="https://www.facebook.com/shahin19sep/" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a class="twitter" href="https://twitter.com/ShahinurAlamBh1" target="_blank"><i class="fab fa-twitter"></i></a></li>
                            <li><a class="github" href="https://github.com/ShahinurAlamBhuiyan" target="_blank"><i class="fab fa-github"></i></a></li>
                            <li><a class="linkedin" href="https://www.linkedin.com/in/shahinur-alam-bhuiyan-572ab0202/" target="_blank"><i class="fab fa-linkedin"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;